export const DRAG_AND_DROP_STATE_ACTION = {
  ITEM_MOVED_UP_TO_NEW_SECTION: 'ITEM_MOVED_UP_TO_NEW_SECTION',
  ITEM_MOVED_DOWN_TO_NEW_SECTION: 'ITEM_MOVED_DOWN_TO_NEW_SECTION',
  ITEM_MOVED_WITHIN_SECTION: 'ITEM_MOVED_WITHIN_SECTION',
  ITEM_MOVED_TO_ADJACENT_AREA: 'ITEM_MOVED_TO_ADJACENT_AREA',
  ITEM_ID_UPDATED: 'ITEM_ID_UPDATED',
  CURRENT_DROPPABLE_SECTION_CHANGED: 'CURRENT_DROPPABLE_SECTION_CHANGED',
  ITEM_DROPPED: 'ITEM_DROPPED',
};

const dragAndDropReducer = (state, { type, payload }) => {
  switch (type) {
    case DRAG_AND_DROP_STATE_ACTION.ITEM_MOVED_WITHIN_SECTION: {
      return {
        ...state,
        currentPosition: payload.currentPosition,
        draggableWithinSectionsItemId: payload.draggableWithinSectionsItemId,
      };
    }
    case DRAG_AND_DROP_STATE_ACTION.ITEM_ID_UPDATED: {
      return {
        ...state,
        draggableBetweenSectionsItemId: payload.draggableBetweenSectionsItemId,
      };
    }
    case DRAG_AND_DROP_STATE_ACTION.CURRENT_DROPPABLE_SECTION_CHANGED: {
      return {
        ...state,
        currentDroppableSectionId: payload,
      };
    }
    case DRAG_AND_DROP_STATE_ACTION.ITEM_MOVED_UP_TO_NEW_SECTION: {
      return {
        ...state,
        currentDroppableSectionId: payload.currentSectionOrder - 1,
      };
    }
    case DRAG_AND_DROP_STATE_ACTION.ITEM_MOVED_DOWN_TO_NEW_SECTION: {
      return {
        ...state,
        currentDroppableSectionId: payload.currentSectionOrder + 1,
      };
    }
    case DRAG_AND_DROP_STATE_ACTION.ITEM_DROPPED: {
      return {
        ...state,
        draggableWithinSectionsItemId: null,
        currentDroppableSectionId: null,
        currentPosition: null,
      };
    }
    default:
      return state;
  }
};

export default dragAndDropReducer;
